import React from 'react'
import { Helmet } from 'react-helmet'
import userManager from 'App/util/UserManager'
import Loader from 'App/components/Loader'
import queryString from 'query-string'
import { getEnv } from 'App/util/env'

type TEnv = {
  OIDC_SIGNIN_TYPE: string
}

const env = getEnv<TEnv>({
  OIDC_SIGNIN_TYPE: process.env.REACT_APP_OIDC_SIGNIN_TYPE || 'redirect'
})

export const LoginPage = () => {
  React.useEffect(() => {
    const params = queryString.parse(window.location.search);
    const hootsuiteUserId = params.userId
    console.log(`SIGNIN TYPE: ${env.OIDC_SIGNIN_TYPE}`);
    console.log(`SIGNIN TYPE REACT: ${process.env.REACT_APP_OIDC_SIGNIN_TYPE}`);
    if(env.OIDC_SIGNIN_TYPE === 'popup'){
      userManager.signinPopup({
        extraQueryParams: {
          hootsuiteUserId: hootsuiteUserId
        },
        extraTokenParams: {
          hootsuiteUserId: hootsuiteUserId
        }
      })
    } else {
      userManager.signinRedirect({
        extraQueryParams: {
          hootsuiteUserId: hootsuiteUserId
        },
        extraTokenParams: {
          hootsuiteUserId: hootsuiteUserId
        }
      })
    }
  }, [])

  return (
    <>
      <Helmet title="Login" />
      <Loader />
    </>
  )
}

export default {
  name: 'Login',
  routeProps: {
    path: '/login',
    component: LoginPage,
  },
}
